import { CanDeactivateFn } from '@angular/router';
import { TestlaufNeuComponent } from './testlauf-neu.component';

export const canDeactivateTestlaufNeu: CanDeactivateFn<TestlaufNeuComponent> = (component) => {
  return component.confirmDeactivate();
};
